import { setApplicationStateById } from '@/contexts/ApplicationContext/ApplicationContext';
import { ApplicationContextInitialState } from '@/contexts/ApplicationContext/state/ApplicationContextInitialState';

export const resetApplicationContext = (setState: setApplicationStateById) => () => {
  setState('RESET', (s) => ({
    ...s,
    ...ApplicationContextInitialState,
    isDirty: false,
    isCompleted: false,
  }));
};
